import axios from 'axios';
import { API_KEY } from '../../config';
import { Loader } from 'google-maps';
import LocationAddress from '../../services/locations/location-address';
import DistanceService from '../../services/locations/distance-service';

interface ISellerSettingShipment {
  isFreeShipping: boolean;
  minimumPurchase: number;
}

const getShopSettingShipment = async (shopId: string) => {
  let { data } = await axios.get(
    `/sellerSettings/shipment/${shopId}`
  );
  return data.data;
};

const checkIsInAll = async ({ product, subCityId }: any) => {
  const objShipment = product?.product?._id?.shipment;
  const { data } = await axios.get(
    `/shipments/check-subcity-is-in-all?subCityId=${subCityId}&shipmentId=${objShipment._id}`
  );
  return data;
};

const loader = new Loader(API_KEY, {});

export const getShippingCost = async (
  order: any,
  deliveryType: any,
  subCityId: any,
  currentLocation: any,
  setting: any
) => {
  let productBoxs = null;
  const google = await loader.load();
  const canShipping = [];
  if (deliveryType === 'จัดส่งปกติ') {
    let productBox = [];
    for (let product of order?.products || []) {
      const shippingFreeArea =
        product?.product?.shipment?.shipmentTypeFreeSomeAreas || [];
      for (let objShipmentArea of shippingFreeArea) {
        let objShipmentBox = objShipmentArea?.subCities.find(
          (subCity: string) => subCity === subCityId
        );
        if (!objShipmentBox) {
          const box = {
            ...product,
            box: product.box + 1,
          };
          product = box;
        }
      }

      const objIsInAll = await checkIsInAll({
        product: product,
        subCityId,
      });
      const isInAll = objIsInAll?.isAllowed ? true : false;
      canShipping.push(isInAll);

      product.isInAll = isInAll;
      product.objArea = objIsInAll?.objArea;
      productBox.push(product);
    }

    let Check = 0;
    for (const checkproductBox of productBox) {
      if (
        checkproductBox.box ===
          checkproductBox.product?.shipment?.shipmentTypeFreeSomeAreas
            ?.length &&
        !checkproductBox.isInAll
      ) {
        Check = Check + 1;
      }
    }

    if (Check === 0) {
      order = {
        ...order,
        deliveryCost: order?.products
          .map((y: any) => 0)
          .reduce((acc: number, curr: number) => {
            return acc + curr;
          }, 0),
        delivery: deliveryType,
      };
    }

    let deliveryCost = order?.deliveryCost || 0;

    const sellerSettingShipment: ISellerSettingShipment =
      await getShopSettingShipment(order.shop._id);

    const freeShipmentMinimumPurchase =
      sellerSettingShipment?.minimumPurchase || 0;

    const isSellerFreeShipment =
      sellerSettingShipment?.isFreeShipping;

    const totalAmountExcludeFreeShipping = productBox
      .filter((product) => {
        const isProductFreeShipping =
          product.product._id.isFreeShipping === undefined
            ? true
            : product.product._id.isFreeShipping;
        return isSellerFreeShipment && isProductFreeShipping;
      })
      .reduce(
        (previous, current) =>
          previous + current.amount * current.wholesalePrice,
        0
      );

    for (const product of productBox) {
      const isProductFreeShipping =
        product.product._id.isFreeShipping === undefined
          ? true
          : product.product._id.isFreeShipping;
      if (
        isSellerFreeShipment &&
        isProductFreeShipping &&
        Number(totalAmountExcludeFreeShipping) >=
          Number(freeShipmentMinimumPurchase)
      ) {
        continue;
      }

      let shipment = 0;
      const obj = product.objArea;

      if (!obj) {
        continue;
      }

      const shipmentType =
        product?.product?._id?.shipment?.shipmentType || '';
      if (shipmentType === 'free_some_area') {
        const price = obj.price;
        shipment = price;
      } else if (shipmentType === 'base_on_quantity') {
        const quantity = product?.amount;
        if (quantity <= obj?.base?.firstQuantity) {
          shipment = obj?.base?.firstPrice;
        } else {
          const amountRemain = quantity - obj?.base?.firstQuantity;
          let amountRate = Math.ceil(
            amountRemain / obj?.base?.nextQuantity
          );
          const piece =
            obj?.base?.firstPrice + amountRate * obj?.base?.nextPrice;
          shipment = piece;
        }
      } else if (shipmentType === 'base_on_weight') {
        const weight = product?.product?._id?.product?.productWeight;
        const weightAll = weight * product?.amount;
        if (weightAll <= obj?.base?.firstQuantity) {
          shipment = obj?.base?.firstPrice;
        } else {
          const amountRemain = weightAll - obj?.base?.firstQuantity;
          let amountRate = Math.ceil(
            amountRemain / obj?.base?.nextQuantity
          );
          const piece =
            obj?.base?.firstPrice + amountRate * obj?.base?.nextPrice;
          shipment = piece;
        }
      } else if (shipmentType === 'base_on_distance') {
        const shopLocation = {
          lat: order?.shop?.lat,
          long: order?.shop?.long,
        };

        let location = { ...currentLocation };

        // if (!isLocationFromCurrent) {
        //   const address = `${postalCode} ${subCity.label} ${state.label}`;
        //   location = await LocationAddress({
        //     google,
        //     address,
        //     isAllResponse: false,
        //   });
        // }

        let dt: any = await DistanceService({
          google,
          from: [`${location.lat}, ${location.long}`],
          to: [`${shopLocation.lat}, ${shopLocation.long}`],
        });

        let distance: any = 0;
        if (dt?.rows && dt?.rows.length) {
          const element = dt.rows[0].elements[0];

          if (element.status === 'OK') {
            distance = element.distance.deliveryType / 1000;
          }
        }
        distance = Math.ceil(distance);
        if (distance <= obj?.base?.firstQuantity) {
          shipment = obj?.base?.firstPrice;
        } else {
          const amountRemain = distance - obj?.base?.firstQuantity;
          let amountRate = Math.ceil(
            amountRemain / obj?.base?.nextQuantity
          );
          const piece =
            obj?.base?.firstPrice + amountRate * obj?.base?.nextPrice;
          shipment = piece;
        }
      }
      deliveryCost += shipment;
    }

    order = {
      ...order,
      deliveryCost,
    };
    if (productBox) {
      productBoxs = productBox;
    }
  } else if (deliveryType === 'จัดส่งพิเศษ') {
    for (const product of order?.products) {
      const shippingFreeArea =
        product?.product?.shipment?.shipmentTypeFreeSomeAreas || [];
      for (const objShipmentArea of shippingFreeArea) {
        const objShipmentBox = objShipmentArea?.subCities.find(
          (x: any) => x === subCityId
        );
        if (!objShipmentBox) {
          // message.warning('นอกเหนือพื้นที่ให้บริการจัดส่ง');
        }
      }
    }
    order = {
      ...order,
      deliveryCost:
        order?.products
          .map((product: any) => {
            const shipmentType =
              product?.product?._id?.shipment?.shipmentType || '';

            if (shipmentType !== 'free_some_area') return 0;

            const shippingFreeArea =
              product?.product?.shipment?.shipmentTypeFreeSomeAreas ||
              [];
            const hasSomeFreeShipmentArea = shippingFreeArea?.find(
              (area: any) =>
                area?.subCities?.find(
                  (subCity: string) => subCity === subCityId
                )
            );
            return (
              (hasSomeFreeShipmentArea &&
                hasSomeFreeShipmentArea.price) ||
              0
            );
          })
          .reduce((acc: number, curr: number) => {
            return acc + curr;
          }, 0) + setting?.specialDelivery,
      delivery: deliveryType,
    };
  } else {
    order = {
      ...order,
      deliveryCost: 0,
      delivery: deliveryType,
    };
  }

  return {
    deliveryCost: order.deliveryCost,
    deliveryType,
    canShipping:
      deliveryType === 'รับเองที่ร้าน'
        ? true
        : canShipping.every((s) => s === true),
  };
  // const newOrders = orders;
  // newOrders[index].shipment = order.deliveryCost;
  // newOrders[index].delivery = order.delivery;
  // if (productBoxs) {
  //   newOrders[index].products = productBoxs;
  // }
  // let lengthOrders = newOrders.length;
  // const Orders = newOrders.map((x: any) => ({
  //   boxdelivery: x?.delivery,
  // }));
  // let numberBox = 0;
  // for (const boxDelivery of Orders) {
  //   const box = boxDelivery.boxdelivery === 'รับที่ร้าน';
  //   if (box) {
  //     numberBox = numberBox + 1;
  //   }
  // }

  // if (newOrders[index].delivery === 'รับที่ร้าน') {
  //   const odrs = newOrders.map((x: any) => ({
  //     ...x,
  //     products: x?.products.map((y: any) => ({ ...y, box: 0 })),
  //   }));
  //   setOrders(odrs);
  //   totalPrices();
  // } else {
  //   setOrders(newOrders);
  //   totalPrices();
  // }
};
